import { useState, useEffect } from 'react';
import { subscribe, unsubscribe } from '@wh/message-bus'; //TODO change to @sb/message-bus once problem fixed with this package deploying and remove ts-ignore
import { MB_BETSLIP_ACTIVE_SELECTIONS } from '../consts';
export const useSelectionsInBetslip = () => {
    const [selectionInBetslip, setSelectionsInBetslip] = useState([]);
    useEffect(() => {
        const token = subscribe(MB_BETSLIP_ACTIVE_SELECTIONS, (t, v) => {
            const data = Array.from(v).map((s) => s.id.replace('OB_OU', ''));
            setSelectionsInBetslip(data);
        });
        return () => unsubscribe(token);
    }, []);
    return selectionInBetslip;
};
